import React from 'react';
import styled, { keyframes } from 'styled-components';

const spinnerKeyFrames = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Spinner = styled.div`
  position: relative;
  animation: spinnerKeyFrames 1.1s infinite linear;
  border-bottom: 0.1em solid;
  border-left: 0.1em solid transparent;
  border-radius: 50%;
  border-right: 0.1em solid transparent;
  border-top: 0.1em solid transparent;
  font-size: 1em;
  height: 1em;
  text-indent: -9999em;
  -ms-transform: translateZ(0);
  -webkit-animation: ${spinnerKeyFrames} 1.1s infinite linear;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  width: 1em;
  overflow: hidden;
`;

export default () => (
  <Wrapper>
    <Spinner />
  </Wrapper>
);
